var _excluded = ["classes"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledDivider } from './StyledDivider';
function Divider(_ref) {
  var classes = _ref.classes,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledDivider, _extends({
    className: classes
  }, rest));
}
Divider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The element used for the root node.
   */
  as: PropTypes.oneOf(['div', 'hr', 'li', 'p', 'span']),
  /**
   * Extend the classes to creates extra styles of the component.
   */
  classes: PropTypes.string,
  /**
   * Defines the color of line
   */
  color: PropTypes.oneOf(['default', 'inherit']),
  /**
   * If `true`, compact vertical margin will be used
   */
  dense: PropTypes.bool,
  /**
   * If `true`, compact vertical margin will be used
   */
  flexItem: PropTypes.bool,
  /**
   * If `true`, vertical margin will be removed.
   */
  disableGutter: PropTypes.bool,
  /**
   * Defines the color of line
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * Defines the style of line
   */
  variant: PropTypes.oneOf(['solid', 'dotted', 'dashed'])
} : {};
Divider.defaultProps = {
  as: 'hr',
  classes: '',
  color: 'default',
  dense: false,
  disableGutter: false,
  flexItem: false,
  orientation: 'horizontal',
  variant: 'dotted'
};
export default Divider;